const joint = {
  jointId: null,
  recordKey: "",
  conditionRating: "",
  covered: "",
  damage: "",
  debrisImpact: "",
  ecmsId: "",
  extrusionInstallDate: null,
  jointComment: "",
  jointLength: null,
  jointLocation: "",
  jointManufacturer: "",
  jointMovement: "",
  jointType: "",
  leaking: "",
  updateDateTime: new Date().toISOString(),
  replacementComment: "",
  replacementReason: "",
  sealInstallDate: null,
  updateUserId: "",
  userKey: "",
  createdDateTime: new Date().toISOString(),
  createUserKey: "",
};
export default joint;
